<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-sm-8 col-lg-6 col-xl-5">
            <div class="box__cont">
                <div [ngClass]="isNotValidInputs ? '' : 'box__title--otp'" class="box__title">
                    <h1>Temporary Challenge Verification</h1>
                    <h2>Enter the temporary challenge sent to your email to continue your password reset.</h2>
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">The input fields are incomplete.</h3>
                </div>
                <div class="box__form">
                    <div [class.error]="isError" class="col-12 box__field">
                        <atram-textbox [parentFormGroup]="searchFormGroup"
                                       type="text"
                                       controlName="temporaryPassword"
                                       label="Temporary Password"
                                       placeholder="Temporary Password"
                                       [isRequired]="true"
                                       [isError]="isError">
                        </atram-textbox>
                    </div>

                    <div *ngIf="isInvalidCode" class="col-12 box__field text-center">
                        <h3 class="box__error-notif">{{ invalidText }}</h3>
                    </div>

                    <div *ngIf="isLockedOut" class="col-12 box__field text-center">
                        <p class="lockout-timer">Time remaining: <strong>{{ lockoutDisplay }}</strong></p>
                    </div>

                    <div class="row justify-content-center">
                        <div class="d-sm-none col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back"
                                            componentClass="btn-submit"
                                            (on-click)="goToForgotPassword()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back"
                                            componentClass="btn-submit"
                                            (on-click)="goToForgotPassword()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
